// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CONTAINER STYLE */
.add-client-page-container {
  animation: fadeIn 0.3s ease-in-out;
}

/* FORM CARD */
.add-client-form-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -4px rgba(0, 0, 0, 0.05);
}

/* SECTION TITLE */
.form-section h3 {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin-top: 0;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* INPUT & TEXTAREA STYLES */
.form-control-input {
  width: 100%;
  padding: 12px 16px;
  font-size: 14px;
  background-color: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  color: #334155;
  outline: none;
  box-sizing: border-box;
  transition: all 0.2s ease-in-out;
}

/* INPUT FOCUS STATE */
.form-control-input:focus {
  background-color: #ffffff;
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
}

/* INPUT HOVER STATE */
.form-control-input:hover {
  border-color: #94a3b8;
}

/* TEXTAREA SPECIFIC OVERRIDE */
textarea.form-control-input {
  resize: vertical;
  font-family: inherit;
}

/* BUTTON HOVER EFFECTS */
.form-actions button {
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.form-actions button:first-child:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
}

.btn-submit-client:not(:disabled):hover {
  background-color: #1d4ed8 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);
}

.btn-submit-client:not(:disabled):active {
  transform: translateY(0);
}

/* RESPONSIVE DESIGN (FOR MOBILE SCREENS) */
@media (max-width: 640px) {
  .form-grid {
    grid-template-columns: 1fr !important; /* মোবাইলে সিঙ্গেল কলাম হয়ে যাবে */
  }
  
  textarea.form-control-input, 
  input[name="machine_id"] {
    grid-column: span 1 !important;
  }
}

/* ANIMATION */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Clients/EditClients.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oFAAoF;AACtF;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,2CAA2C;AAC3C;EACE;IACE,qCAAqC,EAAE,kCAAkC;EAC3E;;EAEA;;IAEE,8BAA8B;EAChC;AACF;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* CONTAINER STYLE */\n.add-client-page-container {\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n/* FORM CARD */\n.add-client-form-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -4px rgba(0, 0, 0, 0.05);\n}\n\n/* SECTION TITLE */\n.form-section h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-top: 0;\n  margin-bottom: 20px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* INPUT & TEXTAREA STYLES */\n.form-control-input {\n  width: 100%;\n  padding: 12px 16px;\n  font-size: 14px;\n  background-color: #f8fafc;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  color: #334155;\n  outline: none;\n  box-sizing: border-box;\n  transition: all 0.2s ease-in-out;\n}\n\n/* INPUT FOCUS STATE */\n.form-control-input:focus {\n  background-color: #ffffff;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);\n}\n\n/* INPUT HOVER STATE */\n.form-control-input:hover {\n  border-color: #94a3b8;\n}\n\n/* TEXTAREA SPECIFIC OVERRIDE */\ntextarea.form-control-input {\n  resize: vertical;\n  font-family: inherit;\n}\n\n/* BUTTON HOVER EFFECTS */\n.form-actions button {\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.form-actions button:first-child:hover {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.btn-submit-client:not(:disabled):hover {\n  background-color: #1d4ed8 !important;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);\n}\n\n.btn-submit-client:not(:disabled):active {\n  transform: translateY(0);\n}\n\n/* RESPONSIVE DESIGN (FOR MOBILE SCREENS) */\n@media (max-width: 640px) {\n  .form-grid {\n    grid-template-columns: 1fr !important; /* মোবাইলে সিঙ্গেল কলাম হয়ে যাবে */\n  }\n  \n  textarea.form-control-input, \n  input[name=\"machine_id\"] {\n    grid-column: span 1 !important;\n  }\n}\n\n/* ANIMATION */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
